import type {
  HistoryTypeFilter,
  ParkingHistoryFilters,
} from 'hooks/useParkingHistoryFilter';
import { create } from 'zustand';

type HistoryState = {
  parkingHistoryFilter: ParkingHistoryFilters;
  parkingHistoryViewFilter: HistoryTypeFilter;
  prepaidPermitHistoryViewFilter: HistoryTypeFilter;
};

type HistoryActions = {
  setParkingHistoryFilter: (filter: ParkingHistoryFilters) => void;
  setParkingHistoryViewFilter: (filter: HistoryTypeFilter) => void;
  setPrepaidPermitHistoryViewFilter: (filter: HistoryTypeFilter) => void;
};

export const useHistoryStore = create<HistoryState & HistoryActions>()(
  (set) => ({
    parkingHistoryFilter: undefined,
    parkingHistoryViewFilter: 'receipts',
    prepaidPermitHistoryViewFilter: 'receipts',
    setParkingHistoryFilter: (filter) => set({ parkingHistoryFilter: filter }),
    setParkingHistoryViewFilter: (filter) =>
      set({ parkingHistoryViewFilter: filter }),
    setPrepaidPermitHistoryViewFilter: (filter) =>
      set({ prepaidPermitHistoryViewFilter: filter }),
  })
);
